<template>
  <div id="payment">
    <CommonHeader />
    <div class="infoColumn"
      ><span class="infoTitle">氏名</span
      ><span class="errorMessage"> {{ errorName }}</span></div
    >
    <el-input
      id="name"
      v-model="name"
      size="medium"
      placeholder="氏名"
      class="inputInfo"
    ></el-input>

    <div class="infoColumn"
      ><span class="infoTitle">性別</span
      ><span class="errorMessage"> {{ errorSex }}</span></div
    >
    <el-select v-model="sex" placeholder="性別" class="inputInfoSelect">
      <el-option
        v-for="item in sexOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>

    <div class="infoColumn"
      ><span class="infoTitle">生年月日</span
      ><span class="errorMessage"> {{ errorBirthday }}</span></div
    >
    <el-date-picker
      v-model="birthday"
      type="date"
      placeholder="生年月日"
      class="inputInfo"
    >
    </el-date-picker>

    <div class="infoColumn"
      ><span class="infoTitle">住所</span
      ><span class="errorMessage"> {{ errorStreetAddress }}</span></div
    >
    <el-input
      v-model="streetAddress"
      type="textarea"
      :rows="4"
      placeholder="東京都渋谷区恵比寿1丁目22−3 シルバープラザ恵比寿101号室(GRIT TODAY EBISU)"
      class="inputInfo"
    >
    </el-input>

    <div class="infoColumn"
      ><span class="infoTitle">メールアドレス</span
      ><span class="errorMessage"> {{ errorEmail }}</span></div
    >
    <el-input
      v-model="email"
      size="medium"
      placeholder="〇〇@u-plus.jp"
      class="inputInfo"
    ></el-input>

    <div class="infoColumnPassword"
      ><span class="infoTitle">ログイン用パスワード</span><br /><span
        class="infoTitle"
        >(英数字大文字小文字を含む8文字以上)</span
      >
      <span class="errorMessage">{{ errorPassword }}</span>
    </div>
    <el-input
      v-model="password"
      size="medium"
      placeholder="Password1234"
      class="inputInfo"
    ></el-input>

    <div class="infoColumn"
      ><span class="infoTitle">電話番号</span
      ><span class="errorMessage"> {{ errorPhoneNumber }}</span></div
    >
    <el-input
      v-model="phoneNumber"
      size="medium"
      placeholder="08012345678"
      class="inputInfo"
    ></el-input>

    <div class="infoColumn">
      <span class="infoTitle">招待コード(任意：お持ちの方は入力ください)</span>
      <span class="errorMessage"> {{ errorInvitationCode }}</span>
    </div>
    <el-input
      v-model="invitationCode"
      size="medium"
      placeholder="Abc123"
      class="inputInfo"
    ></el-input>

    <div class="infoColumn"
      ><span class="infoTitle">カード情報を入力</span
      ><span class="errorMessage"> {{ errorCardToken }}</span></div
    >
    <div class="payjpArea">
      <payjp-checkout
        v-if="cardToken.length === 0"
        api-key="pk_live_130da3be69281c25cec00a00"
        text="カードを情報を入力"
        submit-text="入力完了"
        name-placeholder="田中 太郎"
        @created="onTokenCreated"
        @failed="onTokenFailed"
      />
      <div v-else>カード情報の入力が完了しました</div>
    </div>

    <DefaultButton class="button" @click.native="onNext">確認</DefaultButton>
  </div>
</template>

<script>
import DefaultButton from '@components/atoms/button.vue'
import CommonHeader from '@components/organisms/common_header.vue'
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'Payment',
  components: {
    DefaultButton,
    CommonHeader,
  },
  data() {
    return {
      name: '',
      errorName: '',
      sex: '',
      errorSex: '',
      birthday: '2000/01/01',
      errorBirthday: '',
      streetAddress: '',
      errorStreetAddress: '',
      email: '',
      errorEmail: '',
      password: '',
      errorPassword: '',
      phoneNumber: '',
      errorPhoneNumber: '',
      invitationCode: '',
      errorInvitationCode: '',
      cardToken: '',
      errorCardToken: '',
      last4: '',
      sexOptions: [
        { label: '男', value: '0' },
        { label: '女', value: '1' },
        { label: 'その他', value: '2' },
      ],
    }
  },
  beforeDestroy() {
    window.PayjpCheckout = null
  },
  methods: {
    // カードのToken化に成功したら呼ばれる
    onTokenCreated: function(res) {
      this.last4 = res.card.last4
      this.cardToken = res.id
    },
    // Token化に失敗したら呼ばれる
    onTokenFailed: function() {
      alert('カード情報の入力に失敗しました。カード会社にお問い合わせください')
    },
    onNext: async function() {
      let errorFlg = false
      this.errorName = ''
      this.errorSex = ''
      this.errorBirthday = ''
      this.errorStreetAddress = ''
      this.errorEmail = ''
      this.errorPassword = ''
      this.errorPhoneNumber = ''

      if (this.name.length === 0) {
        this.errorName = '必須項目です'
        errorFlg = true
      }

      if (this.password.length === 0) {
        this.errorPassword = '必須項目です'
        errorFlg = true
      } else if (
        !this.password.match('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$')
      ) {
        this.errorPassword =
          'パスワードは英数字大文字小文字を含む8文字以上で入力してください'
        errorFlg = true
      }

      if (this.sex.length === 0) {
        this.errorSex = '必須項目です'
        errorFlg = true
      }

      if (this.birthday.length === 0) {
        this.errorBirthday = '必須項目です'
        errorFlg = true
      }
      if (this.streetAddress.length === 0) {
        this.errorStreetAddress = '必須項目です'
        errorFlg = true
      }

      if (this.email.length === 0) {
        this.errorEmail = '必須項目です'
        errorFlg = true
      }

      await axios
        .get(`/users/check_email?email=${this.email}`)
        .then((response) => {
          if (response.data) {
            this.errorEmail = 'すでに使用されています'
            errorFlg = true
          }
        })

      if (this.phoneNumber.length === 0) {
        this.errorPhoneNumber = '必須項目です'
        errorFlg = true
      }

      if (this.invitationCode.length !== 0) {
        await axios
          .get(
            `/users/check_invitation_code?invitation_code=${this.invitationCode}`
          )
          .then((response) => {
            if (response.data === null) {
              this.errorInvitationCode = '存在しない招待コードです'
              errorFlg = true
            }
          })
      }

      if (this.cardToken.length === 0) {
        this.errorCardToken = '必須項目です'
        errorFlg = true
      }

      if (!errorFlg) {
        this.$router.push({
          name: 'homme_confirm',
          params: {
            name: this.name,
            sex: this.sex,
            birthday: moment(this.birthday).format('YYYY/MM/DD'),
            password: this.password,
            streetAddress: this.streetAddress,
            email: this.email,
            phoneNumber: this.phoneNumber,
            invitationCode: this.invitationCode,
            last4: this.last4,
            cardToken: this.cardToken,
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/common-settings';
.infoColumn {
  line-height: 40px;
  color: $bg-gray-text-color;
  text-align: left;
  background-color: $bg-gray-color;
}

.infoTitle {
  margin-left: 15px;
}

.infoDescription {
  margin-left: 20px;
}

.inputInfo {
  width: 80%;
  margin: 10px 10px;
  &Select {
    margin: 10px 10px;
  }
}

.button {
  margin-bottom: 20px;
  &Cheer {
    margin-bottom: 20px;
    background-color: $like-color;
  }
}

.errorMessage {
  color: #dd6161;
}

.infoColumnPassword {
  line-height: 25px;
  color: $bg-gray-text-color;
  text-align: left;
  background-color: $bg-gray-color;
}

.payjpArea {
  margin: 20px;
}
</style>
